<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" class="spacey-8 dropdown-trigger" v-on="on">
        <div :title="teamName" class="text-sm grey-900 truncate">{{ teamName }}</div>
        <span class="dropdown-versions-trigger">
          <span class="spacex-4 flex-row">
            <Badge color="grey">{{ $t('v') }}{{ selectedVersion.name }}</Badge>
            <Badge :color="OFFER_STATUS_BADGE[selectedVersion.status]">
              {{ tenderOfferVersionStatuses[selectedVersion.status] }}
            </Badge>
          </span>
          <ArrowIcon />
        </span>
      </div>
    </template>
    <div class="dropdown-body">
      <DropdownMenuElement
        v-for="version in revertedVersions"
        :key="version.id"
        @click="$emit('change-selected-version', version)"
      >
        <TenderOfferVersionDropdownInfo :version="version" />
      </DropdownMenuElement>
    </div>
  </v-menu>
</template>

<script>
  import { VMenu } from 'vuetify/lib';
  import DropdownMenuElement from '@/components/ui/dropdown-menu/DropdownMenuElement';
  import ArrowIcon from '@/assets/icons/chevron-down.svg';
  import TenderOfferVersionDropdownInfo from '@/components/tenders/TenderOfferVersionDropdownInfo';
  import Badge from '@/components/ui/Badge';
  import OFFER_STATUS_BADGE from '@/utils/constants/offer-status-badge';
  import { mapState } from 'vuex';

  export default {
    name: 'TenderVersionDropdown',
    components: {
      TenderOfferVersionDropdownInfo,
      VMenu,
      DropdownMenuElement,
      ArrowIcon,
      Badge,
    },
    props: {
      selectedVersion: {
        type: Object,
        required: true,
      },
      versions: {
        type: Array,
        required: true,
      },
      teamName: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        OFFER_STATUS_BADGE,
      };
    },
    computed: {
      ...mapState('global', ['tenderOfferVersionStatuses']),
      revertedVersions() {
        const computedVersions = [...this.versions];
        return computedVersions.reverse();
      },
    },
  };
</script>

<style scoped>
  .dropdown-body {
    width: 332px;
  }

  .dropdown-trigger {
    width: 100%;
  }

  .dropdown-versions-trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    align-content: center;

    width: 100%;
  }
</style>
